export function median(values: number[]) {
  if (!values.length) return 0
  const sorted = values.slice().sort((a, b) => a - b)
  const half = Math.floor(sorted.length / 2)
  return sorted.length % 2 ? sorted[half] : (sorted[half - 1] + sorted[half]) / 2.0
}
